import React, { createContext, FC, useContext, useState } from 'react';
import { createStore, StoreApi, useStore } from 'zustand';

export interface DragAndDropStore {
  dropped: string[];
  lastId: string;
  setDropped: (dropped: string[]) => void;
  setLastId: (lastId: string) => void;
}

const StoreContext = createContext<StoreApi<DragAndDropStore> | null>(null);

export const DragAndDropProvider: FC = ({ children }) => {
  const [store] = useState(() =>
    createStore<DragAndDropStore>(set => ({
      dropped: [],
      lastId: '',
      setDropped: dropped => set({ dropped }),
      setLastId: lastId => set({ lastId })
    }))
  );

  return (
    <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
  );
};

export const useDragAndDropStore = () => {
  const store = useContext(StoreContext);
  if (!store) throw new Error('Missing DragAndDropProvider');
  return useStore(store);
};
